import { ADD_SCRIPT_LIST, ADD_SCRIPT_LIST_ERROR, ADD_SCRIPT_LIST_SUCCESS, DELETE_SCRIPT_LIST, DELETE_SCRIPT_LIST_ERROR, DELETE_SCRIPT_LIST_SUCCESS, SCRIPT_LIST, SCRIPT_LIST_DETAILS, SCRIPT_LIST_DETAILS_ERROR, SCRIPT_LIST_DETAILS_SUCCESS, SCRIPT_LIST_ERROR, SCRIPT_LIST_SUCCESS, SCRIPT_LIST_UPDATE, SCRIPT_LIST_UPDATE_SUCCESS, SCRIPT_LISTL_UPDATE_ERROR } from './constants';



export default function ScriptReducer(state, action) {


	let scriptdata = [];
    
	switch (action.type) {
	case SCRIPT_LIST:
		return {...state, loading: true, error : false};
	case SCRIPT_LIST_SUCCESS : 
		
        
		if (action.payload && action.payload && action.payload.length > 0) {
			action.payload.map( (item) => {
				let data = {};                        
				data.id = item.id ? item.id : 0;
				data.name = item && item.name ? item && item.name : '';
				data.productionStatus = item && item.productionStatus ? item && item.productionStatus : [] ;
				data.thresholdSecs = item && item.thresholdSecs ? item && item.thresholdSecs : null;
				data.isPidsSpecific = item && item.isPidsSpecific ? item && item.isPidsSpecific : true;
				data.scheduleSecs = item && item.scheduleSecs ? item && item.scheduleSecs : null;
				return scriptdata.push(data);
			});       
			return { ...state, scriptdata: scriptdata ,loading: false, error: false };
		} else {
			if (action.payload && action.payload && action.payload.length === 0) {
				return { ...state, predictionlevel : [] , loading: false, error: false };
			} else {
				return { ...state , loading: false, error: true };
			}
		}
	case SCRIPT_LIST_ERROR : 
		return { ...state, loading : false, error : true };

	case ADD_SCRIPT_LIST:
		return {...state, loading : true, error : false };
	case ADD_SCRIPT_LIST_SUCCESS:
		return {...state, false : true, error : false , };

	case ADD_SCRIPT_LIST_ERROR:
		return {...state, loading : false, error : true };

	case SCRIPT_LIST_DETAILS:
		return { ...state, pending: true };
			
	case SCRIPT_LIST_DETAILS_SUCCESS:
	
		return { ...state, pending: false, details:action.payload, error: false };
	case SCRIPT_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case SCRIPT_LIST_UPDATE:
		return { ...state, pending: false };
	case SCRIPT_LIST_UPDATE_SUCCESS:
		return { ...state, pending: false, error: false };
	case SCRIPT_LISTL_UPDATE_ERROR:
		return { ...state, pending: false, error: true }; 
	case DELETE_SCRIPT_LIST:
		return { ...state, pending: false };
		
	case DELETE_SCRIPT_LIST_SUCCESS:
		return { ...state, pending: false, error: false };
		
	case DELETE_SCRIPT_LIST_ERROR:
		return { ...state, pending: false, error: true };
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}